import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AdminProfileStore } from '../store/admin-profile/admin-profile.store';

@Injectable({
  providedIn: 'root',
})
export class SuperAdminGuard implements CanActivate {
  private router = inject(Router);
  private adminProfileStore = inject(AdminProfileStore);

  canActivate(): boolean | UrlTree {
    if (this.adminProfileStore.isSuperAdmin()) {
      return true;
    }
    return this.router.parseUrl('/dashboard');
  }
}
